import React, { useState } from 'react';
import { RequestEntity, IItemDishesForPagination } from 'types';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import classNames from 'classnames';
import AdditionalInfoSwitch from './components/AdditionalInfoSwitch';
import MainInfoView from './components/MainInfoView/MainInfoView';
import AdditionallyInfoView from './components/AdditionallyInfoView';
import { FullInfoBtn } from '../../../../FullInfoBtn/FullInfoBtn';
import style from './Info.module.scss';

interface IItem {
	isOpenInfo: boolean;
	isUnAssigned: boolean;
	data: IItemDishesForPagination;
	setDishIDForFullInfo: (dishID: string) => void;
}

const Info: React.FC<IItem> = ({ isOpenInfo, isUnAssigned, data, setDishIDForFullInfo }) => {
	const [infoMode, setInfoMode] = useState<'main' | 'additional'>('main');
	const containerClasses = classNames(style.container, { [style.visible]: isOpenInfo });
	const imgWrapperClass = classNames(style.imgWrapper, { [style.itemDisabled]: data.isDisabled });
	const handleSetFullInfo = () => {
		setDishIDForFullInfo(data.id);
	};

	return (
		<div className={containerClasses} data-test="Info">
			<AdditionalInfoSwitch infoMode={infoMode} setInfoMode={setInfoMode} />
			<div className={style.wrapper}>
				<div className={style.infoContainer}>
					<div className={imgWrapperClass}>
						<ImgUploaderByEntityId
							resource={RequestEntity.Dishes}
							entityID={data.filePath ? data.id : ''}
							photoSize="Small"
							isMakeImageRequest={isOpenInfo}
							loaderSize="small"
						/>
					</div>
					{infoMode === 'main' ? (
						<MainInfoView data={data} isUnAssigned={isUnAssigned} />
					) : (
						<AdditionallyInfoView data={data} />
					)}
				</div>
				<div className={style.fullInfoButton}>
					<FullInfoBtn onClick={handleSetFullInfo} />
				</div>
			</div>
		</div>
	);
};

export default React.memo(Info);
